export const API_LOGIN="/gateway/app/auth"
export const API_GET_PROFILE="/gateway/identity/users/profile"
